import React from 'react';
import { useWallet } from '../../context/WalletContext';
import { shortAddr } from '../../utils/format';

export default function ConnectWallet() {
  const { account, connect, disconnect, connecting } = useWallet();

  if (connecting) {
    return (
      <button className="connect-btn" disabled>
        <span className="spinner" style={{ marginRight: 8 }} />
        Connecting
      </button>
    );
  }

  if (!account) {
    return <button className="connect-btn" onClick={connect}>Connect Wallet</button>;
  }

  return (
    <button className="connect-btn connected" onClick={disconnect} title="Disconnect">
      {shortAddr(account)}
    </button>
  );
}
